import superagent from 'superagent';
import { strings } from './strings';
import { systemStore } from 'src/stores';
import { toastError } from 'src/utils/toast';

function request(method, uri, data, token) {
  const task = superagent(method, `${config.api.serverUrl2}${uri}`)
    .set('Content-Type', 'application/json')
    .set('Accept-Language', config.lang)
    .set('Cache-Control', 'no-cache,no-store,must-revalidate,max-age=-1,private')
    .set('Pragma', 'no-cache');

  if (token) {
    task.set('Authorization', `Bearer ${token}`);
  }

  if (data) {
    method === 'GET' ? task.query(data) : task.send(data);
  }

  systemStore.startRequest();

  return task.then(result => {
    systemStore.stopRequest();
    return result.body || result;
  }).catch(error => {
    systemStore.stopRequest();

    error = parseErrorResponse(error);
    if (error.statusCode === 401) {
      toastError(error.text || error.message);
      systemStore.clean();
    }
    throw error;
  })
}

function parseErrorResponse(error) {
  const statusCode = error?.response?.statusCode ?? 500;
  const code = error?.response?.body?.code ?? 'unknown_error';
  let text = error?.response?.body?.message ?? strings[code] ?? code;

  if (statusCode === 401 && code === 'unknown_error') {
    text = strings['invalid_credentials'];
  }
  return { statusCode, code, text };
}

export async function uploadImage(data, token) {
  try {
    const { file_name, upload_url } = await request('GET', '/images/init-upload', { 'mime_type': data.type }, token);

    systemStore.startRequest();
    await superagent.put(upload_url).set('Content-Type', data.type).send(data);
    return { name: data.name, file_name };
  }
  finally {
    systemStore.stopRequest();
  }
}

export async function createDeviceImage(data, token) {
  const { id, name, file_name } = data;
  return await request('POST', `/devices/${id}/images`, { name, file_name }, token);
}

export async function deleteDeviceImage(data, token) {
  const { id, image_id } = data;
  return await request('DELETE', `/devices/${id}/images/${image_id}`, null, token);
}

export async function fetchDeviceImages(data, token) {
  const { id } = data;
  const { items } = await request('GET', `/devices/${id}/images`, null, token);
  return items;
}

export async function createCatchImage(data, token) {
  const { id, name, file_name } = data;
  return await request('POST', `/catches/${id}/images`, { name, file_name }, token);
}

export async function deleteCatchImage(data, token) {
  const { id, image_id } = data;
  return await request('DELETE', `/catches/${id}/images/${image_id}`, null, token);
}

export async function fetchCatchImages(data, token) {
  const { id } = data;
  const { items } = await request('GET', `/catches/${id}/images`, null, token);
  return items;
}

export async function createGroupMap(data, token) {
  const { id, name, file_name } = data;
  return await request('POST', `/groups/${id}/maps`, { name, file_name }, token);
}

export async function updateGroupMap(data, token) {
  const { id, map_id } = data;
  const params = {};
  if (data.name) {
    params.name = data.name;
  }
  if (data.file_name) {
    params.file_name = data.file_name;
  }
  //TODO: check if params is not empty
  return await request('PATCH', `/groups/${id}/maps/${map_id}`, params, token);
}

export async function deleteGroupMap(data, token) {
  const { id, map_id } = data;
  return await request('DELETE', `/groups/${id}/maps/${map_id}`, null, token);
}

export async function fetchGroupMaps(data, token) {
  const { id } = data;
  const { items } = await request('GET', `/groups/${id}/maps`, null, token);
  return items;
}

export async function fetchGroupMap(data, token) {
  const { id, map_id } = data;
  return await request('GET', `/groups/${id}/maps/${map_id}`, null, token);
}